<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="allAssignmentDetail && course" class="container text-center overflow-hidden">
    <div class="row justify-content-center">
        <div class="col-8">
            <h1 class="lifedi-color">
                Assignment
            </h1>
        </div>
    </div>
    <div class="row text-left">
        <div class="col">
            <h4 class="title mt-3">
                {{ course.COURSE_NUMBER }}: {{ course.COURSE_NAME }}
            </h4>
        </div>
    </div>

    <div *ngIf="allAssignmentDetail.length === 0">
        <h3 class="text-center">
            ยังไม่มี Assignment
        </h3>
    </div>

    <div *ngIf="allAssignmentDetail.length > 0">
        <div class="row text-left">
            <div class="col-12">
                <div *ngFor="let item of allAssignmentDetail" [id]="item.COURSE_ID" [value]="item.COURSE_ID">
                    <a style="cursor: pointer;"
                        (click)="assign(item.ASSIGNMENT_ID, item.ASSIGNMENT_NAME, item.COURSE_NAME, item.COURSE_NUMBER)">
                        <mat-card id="assignment-list" class="mt-2">
                            <div class="row">
                                <div class="col-11">
                                    <h5 style="margin: 20px;">
                                        {{ item.ASSIGNMENT_NAME }}
                                    </h5>
                                </div>
                                <div class="col-1" *ngIf="item.WAIT_FEEDBACK > 0">
                                    <span class="dot">
                                        <p style="margin-left: 9px; margin-top: 2px; color: #fff;">
                                            {{ item.WAIT_FEEDBACK }}
                                        </p>
                                    </span>
                                </div>
                            </div>
                        </mat-card>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>